import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";
import { BLOG_POSTS } from "@/data/blog";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export const Blog = () => {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Blog de Rutas - Guías de pesca, camping y senderismo | Ruta 360";
  }, []);

  return (
    <div data-testid="blog-page" className="bg-white min-h-screen">
      <Header />
      <main className="pt-[100px]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 lg:py-20">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <p className="text-[11px] text-[#FF5508] mb-4">
              Blog de Rutas
            </p>
            <h1 className="font-display text-5xl sm:text-6xl uppercase font-semibold leading-none tracking-tight text-[#111418] mb-4">
              Guías para tu
              <br />
              <span className="text-outline">próxima aventura</span>
            </h1>
            <p className="text-black/55 text-base max-w-lg leading-relaxed">
              Pesca, camping y senderismo en México: consejos reales de quienes salen al monte cada fin de semana.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-14">
            {BLOG_POSTS.map((post, i) => (
              <motion.article
                key={post.slug}
                data-testid={`blog-card-${post.slug}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.12 }}
                onClick={() => navigate(`/blog/${post.slug}`)}
                className="group border border-black/10 bg-white cursor-pointer transition-colors duration-300 hover:border-black/30 flex flex-col"
              >
                <div className="h-52 overflow-hidden bg-[#F4F5F6]">
                  <img
                    src={post.image}
                    alt={post.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-6 flex flex-col flex-1">
                <span className="text-[10px] text-[#FF5508] mb-3">
                    {post.category}
                  </span>
                  <h2 className="font-semibold text-xl leading-snug text-[#111418] mb-3">{post.title}</h2>
                  <p className="text-black/55 text-sm leading-relaxed line-clamp-3 mb-5">{post.excerpt}</p>
                  <span className="mt-auto inline-flex items-center gap-2 text-[10px] text-black group-hover:text-[#FF5508] transition-colors">
                    Leer guía <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
